document.addEventListener('DOMContentLoaded', () => {
  const productPath = '/products/mirasai';
  const faqPath = '/pages/preguntas-frecuentes';
  const variantIds = [
    '60305578983758',
    '60305579016526',
    '60305579049294',
    '60305579082062',
    '60305579114830'
  ];

  const route = (path) => {
    const current = new URL(window.location.href);
    const next = new URL(path, window.location.origin);
    ['preview_theme_id', 'locale'].forEach(key => {
      const value = current.searchParams.get(key);
      if (value && !next.searchParams.has(key)) next.searchParams.set(key, value);
    });
    return `${next.pathname}${next.search}${next.hash}`;
  };

  const primary = document.querySelector('#mirasai .vc9-mirasai__button--primary');
  if (primary) primary.href = route(productPath);

  document.querySelectorAll('#v9-about .vc9-brand-story__button--primary').forEach(link => {
    link.href = route(productPath);
  });

  document.querySelectorAll('[data-vc9cg-select]').forEach((card, index) => {
    const variant = variantIds[index];
    if (!variant) return;
    const url = route(`${productPath}?variant=${variant}`);
    card.href = url;
    card.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(url);
    }, true);
  });

  document.querySelectorAll('.vcmp__model-option').forEach(link => {
    const url = route(link.getAttribute('href') || productPath);
    link.href = url;
  });

  document.querySelectorAll('.vc9-footer a').forEach(link => {
    const label = (link.textContent || '').trim().toLowerCase();
    if (label === 'preguntas frecuentes') link.href = route(faqPath);
    if (label === 'mirasai') link.href = route(productPath);
  });

  document.querySelectorAll('.vcmp__quicklinks a[href="/pages/preguntas-frecuentes"], .vcfaq__bottom a[href="/products/mirasai"]').forEach(link => {
    link.href = route(link.getAttribute('href'));
  });
});
